/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileCanvas16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.003 4.5a2.5 2.5 0 11-5.001-.002 2.5 2.5 0 015.001.002zm3.723 4.521c.125-.017.439-.06.911.058.598.149 2.005.504 3.665 1.755.322.252.61.49.698.567V13c-.106-.107-.155-.151-.187-.19-.049-.06-.087-.108-.367-.36l-.092-.082a5.863 5.863 0 00-.896-.708l-.026-.018c-.472-.323-.682-.467-1.434-.79-.766-.33-1.078-.444-1.395-.49l.007.02a1.656 1.656 0 00.068.172c.015.035.027.062.038.104a164.784 164.784 0 00.295.65l.182.421c.265.614.464 1.109.592 1.473.177.502.27.926.154 1.285-.117.36-.398.508-.754.508-.536 0-1.3-.42-1.54-.566l-.085-.052c-.18-.109-.284-.171-.62-.413a2.96 2.96 0 01-.574-.504c-.094-.098-.318-.334-.358-.658-.023-.182.001-.397.107-.549.061-.088.158-.216.438-.25a.647.647 0 01.436.133c.051.036.15.136.269.255a6.168 6.168 0 00.608.554c.202.167.443.364.6.425a23.476 23.476 0 00-.146-.318 28.365 28.365 0 01-.137-.298 11.109 11.109 0 00-.193-.41c-.332-.683-.662-1.38-.806-1.814l-.024-.072c-.13-.388-.204-.612-.128-.885.052-.185.11-.32.336-.437.09-.047.23-.098.348-.114l.01-.001zm.715-6.778l2.485 3.973a.51.51 0 01-.44.784h-4.97a.515.515 0 01-.438-.784l2.485-3.973a.52.52 0 01.878 0zM2 9.82c0-.453.368-.82.823-.82H6.18c.454 0 .822.367.822.821v3.357a.822.822 0 01-.822.821H2.823A.822.822 0 012 13.178V9.82z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default FileCanvas16;
